import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { usePriceGroupsQuery } from "shared/api/price-groups/queries.generated"
import { SelectOption } from "shared/types/Select"

import { NO_PRICE_GROUP_NAME } from "entities/projects/lib/formatPriceGroupName"

export function usePriceGroupOptions() {
  const { t } = useTranslation()
  const { data, loading: isLoadingOptions } = usePriceGroupsQuery()

  const priceGroupOptions: SelectOption<string>[] = useMemo(() => {
    if (!data?.priceGroups.values) return []
    return data.priceGroups.values.map(value => ({
      key: value,
      label: value === NO_PRICE_GROUP_NAME ? t("Price.NoGroup") : value,
      value
    }))
  }, [data?.priceGroups.values])

  return {
    options: priceGroupOptions,
    isLoading: isLoadingOptions
  }
}
